import { jsx as _jsx } from "react/jsx-runtime";
import { Global, css } from '@emotion/react';
import { colors } from './colors';
const globalStyles = css `
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  sub {
    vertical-align: sub;
    font-size: smaller;
  }

  sup {
    vertical-align: super;
    font-size: smaller;
  }

  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }
  body {
    line-height: 1;
    font-size: 16px;
  }
  ol,
  ul {
    list-style: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  .react-datepicker {
    border: 0 !important;
    border-radius: 0 !important;
  }
    
  .ndlib-date-picker-blue .react-datepicker__header,
  .ndlib-date-picker-blue .react-datepicker__header * {
    background-color: ${colors.primary};
    color: white; 
  }

  .ndlib-date-picker-gold .react-datepicker__header,
  .ndlib-date-picker-gold .react-datepicker__header * {
    background-color: ${colors.ndMetallicGold};
    color: white; 
  }

  .ndlib-date-picker-green .react-datepicker__header,
  .ndlib-date-picker-green .react-datepicker__header * {
    background-color: ${colors.ndGreem};
    color: white; 
  }

  .ndlib-date-picker-red .react-datepicker__header,
  .ndlib-date-picker-red .react-datepicker__header * {
    background-color: ${colors.ndTertiary4};
    color: white; 
  }

  .react-datepicker__header:not(.react-datepicker__header--has-time-select) {
    border-top-right-radius: 0 !important;
  }

  .ndlib-date-picker .react-datepicker__header {
    width: 280px;
    border-radius: 0;
  }

  .ndlib-date-picker .react-datepicker__day-names {
    margin-top: 4px;
  }

  .ndlib-date-picker .react-datepicker__month .react-datepicker__month-text {
    padding: 4px;
  }

  .ndlib-date-picker .ndlib-date-picker-highlight {
    background-color: ${colors.ndTertiary1};
    color: ${colors.background};
    border-radius: 0.3rem;
  }

  .ndlib-date-picker .ndlib-date-picker-pastdate {
    color: ${colors.lightGray};
  }

  @font-face {
    font-family: GPCMed;
    font-display: swap;
    url('https://static.nd.edu/fonts/gp-min/gpc-medium.woff2') format('woff2'),
    url('https://static.nd.edu/fonts/gp-min/gpc-medium.woff') format('woff'),
    url('https://static.nd.edu/fonts/gp-min/gpc-medium.ttf')
    format('truetype');
  }

  a {
    color: ${colors.ndBlueBright}
  }
`;
export const GlobalStyles = () => {
    return _jsx(Global, { styles: globalStyles });
};
